<template>
  <div class="bai-wrapper">
    <fn-icon
      :icon="$t('buyAgain.info.icon')"
      color="black"
      size="xs"
    />
    <span
      class="bai-text"
      v-html="$t('buyAgain.info.text', { period: periodInMonths, timesBought: timesBought })"
    />
  </div>
</template>

<script>
export default {
  props: {
    periodInMonths: {
      type: Number,
      default: null,
    },
    timesBought: {
      type: Number,
      default: null,
    },
  },
};
</script>

<style lang="scss" scoped>
.bai-text {
  line-height: $pad;
  padding-left: math.div($pad, 3);
}
.bai-wrapper {
  display: flex;
}
</style>
